import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import axios from "axios";
import { apiUrl } from "../../../constants";
import Dropdown2 from "../dropdown2/Dropdown2";

const Device = ({ control, register }) =>  {
  const [result, setResult] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function getAll() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${apiUrl}/api/formsettings/device`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setResult(data);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          console.error(e.response.data.message);
        }
      }
    }
    getAll();
  }, []);

  useEffect(() => {
    const options = [];
    result.forEach((currentDevice) => {
      const newOption = {
        label: currentDevice.label,
        value: currentDevice.value,
      };
      options.push(newOption);
    });
    setOptions(
      options.sort((a, b) =>
        a.value === b.value ? 0 : a.value < b.value ? -1 : 1
      )
    );
  }, [result]);

  return (
    <section className="device-wrapper">
      <div>
        <Controller
          control={control}
          name="device"
          render={({ field: { onChange, value } }) => (
            <Dropdown2
              label="Device * "
              options={options}
              name="device"
              value={value}
              onChange={onChange}
              fieldRef={register("device", { required: true })}
            />
          )}
        />
      </div>
    </section>
  );
};

export default Device;
